export const SET_CLIENT_HEIGHT = (state, value) => {
  state.clientHeight = value
}
export const SET_CLIENT_WIDTH = (state, value) => {
  state.clientWidth = value
}

/**
 * loading 相关
 */
export const OPEN_LOADING = (state, count = 1) => {
  if (count > 0) {
    state.loadingMain += count
  }
}

export const CLOSE_LOADING = (state, count) => {
  // 有效的关闭数
  if (count > 0 && count <= state.loadingMain) {
    state.loadingMain -= count
  } else {
    // 否则默认全部关闭
    state.loadingMain = 0
  }
}

export const COLLAPSE_MENU = (state, collapse = true) => {
  state.collapseMenu = collapse
}

export const SET_AUTO_COLLAPSE_MENU = (state, value = true) => {
  state.autoCollapseMenu = !!value
  localStorage.setItem('autoCollapseMenu', String(state.autoCollapseMenu))
}



// WEBPACK FOOTER //
// ./src/store/mutations.js